// extracted by mini-css-extract-plugin
export default {"collapseButton":"collapseButton-atA70","titleContainer":"titleContainer-WpcsE"};